import emitter from "tiny-emitter/instance";

export const $bus = {
  $on: (...args) => emitter.on(...args),
  $once: (...args) => emitter.once(...args),
  $off: (...args) => emitter.off(...args),
  $emit: (...args) => emitter.emit(...args),
};
export function validateEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export const pdfCoverUrl = (fileId) =>
  `${process.env.VUE_APP_DASHBOARD}/preview/${fileId}`;

export const styleHelper = {
  innerHeight: window.innerHeight,
  isMobile: window.matchMedia("(max-width: 960px )").matches,
};
